jQuery(function (e) {
  var fileReader = new FileReader();
  var filterType = /^(?:image\/bmp|image\/cis\-cod|image\/gif|image\/ief|image\/jpeg|image\/jpeg|image\/jpeg|image\/pipeg|image\/png|image\/svg\+xml|image\/tiff|image\/x\-cmu\-raster|image\/x\-cmx|image\/x\-icon|image\/x\-portable\-anymap|image\/x\-portable\-bitmap|image\/x\-portable\-graymap|image\/x\-portable\-pixmap|image\/x\-rgb|image\/x\-xbitmap|image\/x\-xpixmap|image\/x\-xwindowdump)$/i;


    setTimeout(function(){ 
     $('.Stage3').append(`<div class="power-types-wrapper">
    <span id="eyetest-div1" class="myspan sendLater">My Prescription is at Optica</span><br>
    <div class="show-eyetest1" style="display: none;">
        <div class="product-form__item product-form__item--send Email">
            <div class="head_label ctnnbutton CtnboX">
                <h3 class="continue-btn">Continue</h3>
            </div>
        </div>
    </div>
</div>
     <div class="power-types-wrapper">
          <span id="eyetest-div" class="myspan sendLater">I don't have a Prescription</span><br>
          <div class="show-eyetest" style="display: none;">
              <div class="product-form__item product-form__item--send Email">
                  <div class="head_label ctnnbutton CtnboX">
                      <a href="/pages/schedule-an-eye-test" class="continue-btn" target="_blank" rel="noopener noreferrer">Book an Eye Test</a>
                  </div>
              </div>
          </div>
      </div>`);    
      console.log('setTimeout');
      $("#eyetest-div1").click(function(){ 

          if($('.show-eyetest1').is(':visible')){
             $('#eyetest-div1').removeClass('active-toggle'); 
          }else{
            $('#eyetest-div1').addClass('active-toggle');
          }
           $(".show-eyetest1").toggle();
            
        }); 

       $("#eyetest-div").click(function(){ 

          if($('.show-eyetest').is(':visible')){
             $('#eyetest-div').removeClass('active-toggle'); 
          }else{
            $('#eyetest-div').addClass('active-toggle');
          }
           $(".show-eyetest").toggle();
            
        });

       $("#prescriptionUpload").click(function(e){ 
          $('.showselect').toggle();
      }); 

      //  $("#sendLater").click(function(e){ 
      //     $('.showemail').toggle();
      // }); 

      $('[data-menu-item="sendLater"]').click(function(event) {
          console.log(event);
          $('.showemail').toggle();
      });
    
  }, 4000);
  
  fileReader.onload = function (event) {
    var image = new Image();

    image.onload = function () {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      canvas.width = image.width / 2;
      canvas.height = image.height / 2;
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      if (!jQuery("#original-ImgProductPrescriptionUploadImg").length) {
        jQuery(".prescription_head .customphoto").prepend(
          '<img id="original-ImgProductPrescriptionUploadImg" />'
        );
      }
      if (jQuery(".PdfProductPrescriptionUpload").length) {
        jQuery(".PdfProductPrescriptionUpload").hide();
      }
      jQuery("#original-ImgProductPrescriptionUploadImg").show();
      document.getElementById(
        "original-ImgProductPrescriptionUploadImg"
      ).src = canvas.toDataURL();
      //image.src;
      // 		jQuery(".prescription_head .customphoto").prepend('<img id="upload-PreviewProductPrescriptionUploadImg" />');
      //         document.getElementById("upload-PreviewProductPrescriptionUploadImg").src = canvas.toDataURL();
    };
    image.src = event.target.result;
  };



  var loadImageFile = function () {
    var uploadImage = document.getElementById("custom_photo");
    if (typeof uploadImage.files == "undefined") {
      return;
    }
    //check and retuns the length of uploded file.
    if (uploadImage.files.length === 0) {
      return;
    }

    //Is Used for validate a valid file.
    var uploadFile = document.getElementById("custom_photo").files[0];
    if (!filterType.test(uploadFile.type)) {
      if (jQuery("#original-ImgProductPrescriptionUploadImg").length) {
        jQuery("#original-ImgProductPrescriptionUploadImg").hide();
      }
      if (!jQuery(".PdfProductPrescriptionUpload").length) {
        jQuery(".prescription_head .customphoto").prepend(
          '<div class="PdfProductPrescriptionUpload" />'
        );
      }
      jQuery(".PdfProductPrescriptionUpload").show();
      jQuery(".PdfProductPrescriptionUpload").html(
        "File Uploaded Successfully"
      );

      //alert("Please select a valid image.");
      return;
    }

    fileReader.readAsDataURL(uploadFile);
  };
  var b64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };
  var changePriceClass = function (ele) {
    try {
      var frameValue = ele.find(".property-value").html();
      var framePrice = frameValue.split("KSh ");
      frameValue = framePrice[0];
      framePrice = "KSh " + framePrice[1];
      ele.find(".property-value").hide();
      ele
      .find(".property-value")
      .after(
        '<span class="frameValue">' +
        frameValue +
        '</span><span class="framePrice">' +
        framePrice +
        "</span>"
      );
    } catch (err) {
      console.log(err);
    }
  };
  var changeImage = function (ele) {
    var imageSrc = ele.find(".lightbox").attr("href");
    var ext = imageSrc.split(".").pop();
    ele.find(".lightbox").attr("target", "_blank");

    //       if(ext != 'pdf'){
    //         ele.find('.property-label').after('<img class="CartPrescriptionUploadImg"  src="'+ imageSrc +'" />')
    //         ele.find('.lightbox').hide();
    //       }else{
    //           ele.find('.property-label').after('<div class="CartPrescriptionUploadPdf" ></div>')
    //       }
  };
  jQuery("#cartform #show_prescription .type_details").each(function (i) {
    if (jQuery(this).find(".property-label").html() == "Frame") {
      changePriceClass(jQuery(this));
    }
    if (jQuery(this).find(".property-label").html() == "Prescription Upload") {
      changeImage(jQuery(this));
    }
    if (jQuery(this).find(".property-label").html() == "Lens Type") {
      changePriceClass(jQuery(this));
    }
  });
  (changeMainImage = function () {
    var t = e(".product-form .variations .swatch-element .selected label").attr(
      "data-thumb"
    );
    e(".side_option .main_product_image .img img").attr("src", t);
  }),
    e(document).on("click", "#product .product-info .addToCartBtn", function (t) {
    if ((t.preventDefault(), e(this).hasClass("select_lense")))
      e("#product .side_option").addClass("active"),
        e(".slider-header").addClass("hide"),
        e("body").addClass("overflow_hidden");
    else {
      var i = e(this).closest(".product-form");
      ajaxForm(i, function () {
        window.location.href = "/cart";
      });
    }
  }),
    e(document).on("click", ".side_option .close", function () {
    closeSideOption();
  }),
    e(".head.lens_check[data-title='zero-power']").click(function () {
    e('ul.timeline li[data-index="2"]').addClass("hide").removeClass("show"),
      e(".optica_fr").removeClass("hide").addClass("show"),
      e(".optica_pr").addClass("hide").removeClass("show"),
      e("ul.timeline.without_prescription")
    .addClass("show")
    .removeClass("hide"),
      e("ul.timeline.with_prescription").addClass("hide").removeClass("show");
  }),
    e(".head.lens_check[data-title='single-vision']").click(function () {
    e('ul.timeline li[data-index="2"]').addClass("show").removeClass("hide"),
      e(".optica_fr").removeClass("show").addClass("hide"),
      e(".optica_pr").addClass("show").removeClass("hide"),
      e("ul.timeline.without_prescription")
    .addClass("hide")
    .removeClass("show"),
      e("ul.timeline.with_prescription").addClass("show").removeClass("hide");
  }),
    e(".head.lens_check[data-title='digital-screen']").click(function () {
    e('ul.timeline li[data-index="2"]').addClass("show").removeClass("hide"),
      e(".optica_fr").removeClass("show").addClass("hide"),
      e(".optica_pr").addClass("show").removeClass("hide"),
      e("ul.timeline.without_prescription")
    .addClass("hide")
    .removeClass("show"),
      e("ul.timeline.with_prescription").addClass("show").removeClass("hide");
  }),
    e(document).on("click", ".side_option .event-option", function () {
    var t = e(this).closest(".toggle_div"),
        i = e(this).closest(".tab_content"),
        n = !1;
    e(t).hasClass("prescription")
    ? ((n = !0),
       e(".head", i).removeClass("active"),
       e(this).closest(".head").addClass("active"),
       selectLensCheck(t))
    : e(t).hasClass("lens-product") &&
      ((n = !0),
       e(".head", i).removeClass("active"),
       e(this).closest(".head").addClass("active"),
       productOptionFinalView(t)),
      n &&
      setTimeout(function () {
      changeOption(t, !1);
    }, 500);
  }),
    e(document).on("click", ".side_option .head_label h3", function () {
    var t = e(this).closest(".toggle_div"),
        i = e(this).closest(".tab_content"),
        n = !1;
    e(t).hasClass("lens-product")
    ? ((n = !0),
       e(".head", i).removeClass("active"),
       e(this).closest(".head").addClass("active"),
       productOptionFinalView(t))
    : e(t).hasClass("prescription-data") &&
      ((n = !0),
       e(".head", i).removeClass("active"),
       e(this).closest(".head").addClass("active"),
       productOptionFinalView(t)),
      n &&
      setTimeout(function () {
      changeOption(t, !1);
    }, 500);
  }),
    e("#with-rx .cart-details .item_total").click(function (t) {
    e(window).width() < 768 &&
      (t.preventDefault(),
       e(this)
       .closest(".nav-arrow")
       .find("#show_prescription")
       .stop()
       .slideToggle(),
       e(this)
       .find("span")
       .stop()
       .toggleClass("down_arrow_icon up_arrow_icon"));
  }),
    e(document).on("click", ".side_option .back_option .back", function () {
    var t = e(this).closest(".toggle_div");
    changeOption(t, !0);
  }),
    e(document).on("click", ".side_option .edit_btn", function () {
    var t = e(this);
    resetProductOption(t);
  }),
    e(document).on("click", ".side_option .second_frame_buy", function (t) {
    var i = e(this);
    e.fancybox.showLoading();
  }),
    (generateUniqueId = function () {
    return (
      "b_" + new Date().valueOf() + Math.random().toFixed(8).substring(2)
    );
  }),
    e(document).on("click", ".side_option .bundle_add", function () {
    var t = e(this);

    loadingicon();
    setTimeout(function(){
      showLoading(e);
    }, 500);

  }),
    (openSideOption = function () {
    e("#product .side_option").addClass("active"),
      e(".slider-header").addClass("hide"),
      e("body").addClass("overflow_hidden");
  }),
    (closeSideOption = function () {
    e("#product .side_option").removeClass("active"),
      e("#product .side_option .head").removeClass("active"),
      e("#product .side_option .toggle_div").removeClass("active"),
      e("#product .side_option .toggle_div.prescription").addClass("active"),
      e("body").removeClass("overflow_hidden");
    e(".slider-header").removeClass("hide");
  }),
    (changeOption = function (t, i) {
    var n = e(t).closest(".side_option"),
        o = parseInt(e(t).attr("data-index"));
    if (i) {
      e('.toggle_div[data-index="' + (s = o - 1) + '"] .head', n).removeClass(
        "active"
      ),
        0 == o
      ? openSideOption()
      : (e(".toggle_div", n).removeClass("active"),
         e("ul.timeline li", n).removeClass("active"),
         e('.toggle_div[data-index="' + s + '"]', n).addClass("active"),
         e('ul.timeline li[data-index="' + s + '"]', n).addClass(
        "active"
      ));
    } else {
      var s = o + 1;
      e(".toggle_div", n).removeClass("active"),
        e("ul.timeline li", n).removeClass("active"),
        e('.toggle_div[data-index="' + s + '"]', n).addClass("active"),
        e('ul.timeline li[data-index="' + s + '"]', n).addClass("active");
    }
    e(".timeline li.active")
    .prevUntil("li.active")
    .removeClass("step-disable")
    .addClass("step-completed");
    e(".timeline li.active")
    .nextUntil("li.active")
    .addClass("step-disable")
    .removeClass("step-completed");
  }),
    (selectLensCheck = function (t) {
    var i = parseInt(e(t).attr("data-index")) + 1,
        n = e(t).find(".head.active").attr("data-prescription"),
        o = e('.toggle_div[data-index="' + i + '"]'),
        s = e(".head[data-tag]", o),
        r = 0;
    e(s).each(function (t, i) {
      e(i).attr("data-tag").split(",").indexOf(n) > -1
      ? ((r += 1), e(i).removeClass("hide"))
      : e(i).addClass("hide"),
        r <= 0
      ? e(".head.no_product_found", o).removeClass("hide")
      : e(".head.no_product_found", o).addClass("hide");
    });
  }),
    (productOptionFinalView = function (t) {
    var i = parseInt(e(t).attr("data-index")) + 1,
        n = e('.toggle_div[data-index="' + i + '"]'),
        o = e(t).closest(".side_option"),
        s = e(".toggle_div.prescription .head.active", o),
        r = e(".toggle_div.lens-product .head.active", o),
        a = e(o)
    .closest(".product_form")
    .find(".product-form")
    .find(".swatch-element.medium span")
    .text(),
        l = e(o)
    .closest(".product_form")
    .find(".product-focus")
    .find(".price-new")
    .text(),
        p = e(o).closest(".product_form").find("h2.name").text();
    e(".prescription_type_head .sub_head p", n)
    .text("")
    .text(e(".head_label h3", s).text()),
      e(".lens_head .sub_head p", n)
    .text("")
    .text(e(".head_label h3", r).text()),
      e(".lens_head .sub_head .c_price", n)
    .text("")
    .text(e(".head_label .c_price", r).text()),
      e(".lens_head .sub_head .p_price", n)
    .text("")
    .text("" + e(".head_label .p_price", r).text()),
      e(".frame_type_head .sub_head p", n).text("").text(a),
      e(".frame_type_head .sub_head .p_price", n).text("").text(l),
      e(".frame_type_head .sub_head p", n).text("").text(p),      
      e(".final_view_bottom_wrap .sub_total .price", n).text("").text(e(".head_label .p_price", r).attr("data-totalprice"));
    if (!jQuery(".PdfProductPrescriptionUpload").length) {
      jQuery(".prescription_head .customphoto").prepend('<div class="PdfProductPrescriptionUpload" >File Uploaded Successfully</div>');
    } else {
      jQuery(".PdfProductPrescriptionUpload").html("File Uploaded Successfully");
    }

    jQuery(".baseInfo").hide();
    var id = jQuery(".myspan.active-toggle").data("show");
    jQuery("#" + id).parent().show();
  }),
    (resetProductOption = function (t) {
    var i = e(t).closest(".side_option");
    e(".toggle_div", i).removeClass("active"),
      e(".toggle_div .head", i).removeClass("active"),
      e(".prescription", i).addClass("active"),
      $(".customphoto").val("").trigger("change");
  }),
    e(document).on(
    "click",
    ".side_option .toggle_div.prescription.active .back",
    function () {
      closeSideOption();
    }
  );

  $(window).on("scroll", function () {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 481) {
      if ($(this).scrollTop() > 650) {
        $(".product-single__add-to-cart.button_wrapper").show(),
          $(".product-single__add-to-cart.button_wrap button.select_lense").hide();
      } else {
        $(".product-single__add-to-cart.button_wrapper").hide(),
          $(".product-single__add-to-cart.button_wrap button.select_lense").show();
      }
    }
  });

  $(".baseInfo .head_label").on('click', function() {
    $(this).toggleClass("active");
    $(".baseInfo .sub_head").toggleClass("show"); 
  }); 

  var loadingicon = function() {
    //$("#shopify-section-product-template").append('<div class="loaderajax"></div>');
    //$("#shopify-section-product-template #ProductSection-product-template").css("opacity", "0.2");
    $(".opticaLensClass").addClass("wait");
    $(".bundle_add").html("");
    $(".bundle_add").html('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Loading...');	

    //showLoading(e);
  };

  showLoading = function (e) {
    var framePrice = $aj("#framePrice").val();
    var lensPrice = $aj(".lens-product .head.active .p_price").attr("data-lensprice");
    var totalPrice = $aj(".lens-product .head.active .p_price").attr("data-price");
    var productTitle = $aj("#productTitle").val();
    var productSku = $aj(".prescription-frame-sku").val();
    var variantTitle = $aj("#variantTitle").val();
    var productImage = $aj("#productImage").val();
    var productVendor = $aj("#productVendor").val();
    var CustomPhoto = $aj("#custom_photo").val();
    var variantId = $aj("#frameId").val();
    // var variantId = $aj("#frameId").val();
    var variantTitle = $aj("#variantTitle").val() + " - UGX " + $aj("#framePrice").val();
    var variantSku = $aj(".prescription-frame-sku").val()
    var productType = " " + $aj("#productType").val();
    var prescriptionType = " " + $aj(".sendLater.myspan.active-toggle").text();
    var stage1Val = " " + $aj(".toggle_div.prescription .head.active .head_label h3").text();
    var stage2Val = " " + $aj(".toggle_div.lens-product .head.active .head_label h3").text() + " - " + $aj(".toggle_div.lens-product .head.active .p_price").text();
    
    var base64ToBlob = function (base64, mime) {
      mime = mime || "";
      var sliceSize = 1024;
      var byteChars = window.atob(base64);
      var byteArrays = [];

      for (
        var offset = 0, len = byteChars.length;
        offset < len;
        offset += sliceSize
      ) {
        var slice = byteChars.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: mime });
    };
    const totalPrices = parseInt(framePrice) + parseInt(lensPrice.split(',').join(""))
    alert(totalPrices)
    var formData = new FormData();
    var file = $aj("#custom_photo").get(0).files[0];
    formData.append("file", file);
    formData.append("shop", shopurl);
    formData.append("productid", productid);
    formData.append("framePrice", totalPrices);
    //formData.append("lensPrice", lensPrice);
    // formData.append("totalPrice", totalPrices);
    formData.append("productTitle", productTitle);
    formData.append("productSku", productSku);
    formData.append("variantTitle", variantTitle);
    formData.append("productImage", productImage);
    formData.append("productVendor", productVendor);

    //custom_photo
    //return false;
    //$aj(".opticaLensClass").addClass("wait");
    //$aj(".bundle_add").html("");
    //$aj(".bundle_add").html('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Loading...');	
    const productData = {product: {
      "shop_id": "1",
      "product_id": Math.floor(Math.random() * 10**13),
      "product_title": productTitle,
      "product_vendor": productVendor,
      "variant_id": parseInt(variantId),
      "variant_title": $aj("#variantTitle").val(),
      "variant_price": totalPrices + ".00",
      "image_error": ""
    }}
    
      let productInfo = {
        'items': [{
          'id': parseInt(variantId),
          'quantity': 1,
          'variant_price': totalPrices + ".00",
          'properties': {
            "Frame": variantTitle,
            "SKU": variantSku,
            "Prescription Type": prescriptionType,
            // "Prescription Upload": customphotoVal,
            "Lens": stage1Val,
            "Lens Type": stage2Val,
          },
        }],
      };

    fetch("https://lensesapp.ug.optica.africa/shopify_optica/optica_front/addProductAction", {
      method: 'POST',
      headers: {
        'Content-Type': "multipart/form-data",
      },
      body: formData
    }).then(res => {
      sessionStorage.setItem('LinodeRes', JSON.stringify(res))
      addToCart(res)
    }).catch(err => {
      console.error(err)
      sessionStorage.setItem('err', JSON.stringify(err))
      addToCart(productInfo)
    })

    function addToCart(data){
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(res => {
        sessionStorage.setItem('AddToCartRes', JSON.stringify(res))
        window.location.href = window.Shopify.routes.root + "cart";
      })
    }
  
    /*
    $aj.ajax({
      url: "https://lensesapp.optica.africa/shopify_optica/optica_front/addProductAction",
      type: "POST",
      async: false,
      cache: false,
      contentType: false,
      enctype: "multipart/form-data",
      processData: false,
      data: formData,
      success: function (response) {
        let res;
        res instanceof Object ? res = JSON.parse(response) : res = productData
        sessionStorage.setItem('res', JSON.stringify(res))
        console.log(res,"goms");
        var cust_photo = "";
        cust_photo = res?.product?.custom_photo;

        var sphrVal = (sphlVal = cylrVal = cyllVal = axrVal = axlVal = pdoptVal = pdoptrVal = pdoptlVal = variantId = variantTitle = "");
        var cylrData = (cyllData = prescriptionType = productType = "");

        customphotoVal = cust_photo;

        variantId = $aj("#frameId").val();
        variantTitle = $aj("#variantTitle").val() + " - UGX " + $aj("#framePrice").val();
        variantSku = $aj(".prescription-frame-sku").val()
        productType = " " + $aj("#productType").val();

        prescriptionType = " " + $aj(".sendLater.myspan.active-toggle").text();

        stage1Val = " " + $aj(".toggle_div.prescription .head.active .head_label h3").text();

        stage2Val = " " + $aj(".toggle_div.lens-product .head.active .head_label h3").text() + " - " + $aj(".toggle_div.lens-product .head.active .p_price").text();

        $aj.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "add.js",
          dataType: "json",
          crossDomain : true,
          data: {
            id: parseInt(res.product.variant_id),
            quantity: "1",
            properties: {
              "Frame": variantTitle,
              "SKU": variantSku,
              "Prescription Type": prescriptionType,
              "Prescription Upload": customphotoVal,
              "Lens": stage1Val,
              "Lens Type": stage2Val,
            },
          },
          success: function (data) {
            window.location.href = "/cart";
            sessionStorage.setItem('addjs', JSON.stringify(data))
            setTimeout(function () {
            }, 1500);
          }
        });
      },
    });
    */
  };
});

